import { render, staticRenderFns } from "./fileViewer.vue?vue&type=template&id=3b4e5040&scoped=true&"
import script from "./fileViewer.vue?vue&type=script&lang=js&"
export * from "./fileViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e5040",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notifications: require('/codebuild/output/src985175027/src/nuxt-thefutures/components/notifications/Index.vue').default,ProfileImage: require('/codebuild/output/src985175027/src/nuxt-thefutures/components/ProfileImage.vue').default,Toast: require('/codebuild/output/src985175027/src/nuxt-thefutures/components/Toast.vue').default,ToastNotification: require('/codebuild/output/src985175027/src/nuxt-thefutures/components/ToastNotification.vue').default})
